<template>
  <v-expansion-panel>
    <AddressTemplate :Address="CustomerAddress"
                     :loading="loading">
    </AddressTemplate>
  </v-expansion-panel>
</template>


<script>
import AddressTemplate from "@/components/Preview/Customer/AddressTemplate.vue";

export default {
  name: "CustomerAddressPreview",
  props: {
    CustomerAddress: Object,
    loading: Boolean,
  },
  components: { AddressTemplate },

  data: () => ({}),

  mounted() {},

  methods: {},

  computed: {},

  watch: {},
};
</script>